import React, { useContext, useEffect, useState } from "react";
import profileImage from "../../assets/svgs/Ellipse 1931.svg";
import arrow from "../../assets/svgs/arrow.svg";
import { LangContext } from "../../utils/contaxt";
import { toast } from "react-toastify";

const Horizontal =() => {
  const { lang, first_Name, Last_Name, setlang, setfirst_Name, setLast_Name } =
    useContext(LangContext);

  const role = localStorage.getItem("role");
  const name = localStorage.getItem("name");
  const image = localStorage.getItem("image");
  const [status, setstatus] = useState(false);

  // Debug logging
  console.log("🚀 ~ Horizontal ~ lang:", lang);
  console.log("🚀 ~ Horizontal ~ image:", image);
  console.log("🚀 ~ Horizontal ~ first_Name:", first_Name);
  console.log("🚀 ~ Horizontal ~ Last_Name:", Last_Name);

  useEffect(() => {
    CheckWallet();
    
    // Listen for wallet connection changes
    const handleAccountsChanged = (accounts) => {
      console.log('Accounts changed:', accounts);
      if (accounts && accounts.length > 0) {
        setstatus(true);
      } else {
        setstatus(false);
      }
    };
    
    // Listen for wallet disconnection
    const handleDisconnect = () => {
      console.log('Wallet disconnected');
      setstatus(false);
    };
    
    // Listen for chain changes (when user switches networks)
    const handleChainChanged = (chainId) => {
      console.log('Chain changed:', chainId);
      // Re-check wallet status when chain changes
      CheckWallet();
    };
    
    // Add event listeners
    if (window.ethereum) {
      window.ethereum.on('accountsChanged', handleAccountsChanged);
      window.ethereum.on('disconnect', handleDisconnect);
      window.ethereum.on('chainChanged', handleChainChanged);
    }
    
    // Periodic check for wallet status (every 30 seconds) - reduced frequency
    const statusCheckInterval = setInterval(() => {
      CheckWallet();
    }, 30000);
    
    // Cleanup event listeners and interval
    return () => {
      if (window.ethereum) {
        window.ethereum.removeListener('accountsChanged', handleAccountsChanged);
        window.ethereum.removeListener('disconnect', handleDisconnect);
        window.ethereum.removeListener('chainChanged', handleChainChanged);
      }
      clearInterval(statusCheckInterval);
    };
  }, [image, first_Name, Last_Name]);
  const CheckWallet = async () => {
    try {
      // Check if MetaMask is available
      if (!window.ethereum) {
        console.log('MetaMask not available');
        setstatus(false);
        return;
      }
      
      // Check if wallet is already connected without prompting
      const accounts = await window.ethereum.request({
        method: "eth_accounts",
      });
      
      if (accounts && accounts.length > 0) {
        // We have accounts, but need to verify MetaMask is actually unlocked
        try {
          // Try to get balance to verify MetaMask is unlocked and responsive
          await window.ethereum.request({
            method: "eth_getBalance",
            params: [accounts[0], "latest"]
          });
          
          // If we get here, MetaMask is unlocked and responsive
          if (!status) {
            console.log('Wallet is connected and unlocked, setting status to connected');
          }
          setstatus(true);
        } catch (balanceError) {
          // If balance check fails, MetaMask is probably locked
          console.log('MetaMask is locked or not responsive:', balanceError.message);
          if (status) {
            console.log('Setting status to disconnected - MetaMask is locked');
          }
          setstatus(false);
        }
      } else {
        // No accounts found
        if (status) {
          console.log('No accounts found, setting status to disconnected');
        }
        setstatus(false);
      }
    } catch (error) {
      console.error('Error checking wallet connection:', error);
      setstatus(false);
    }
  };

  const handleWalletAction = async () => {
    console.log('Wallet button clicked, current status:', status);
    try {
      if (status) {
        console.log('Disconnecting wallet...');
        // If connected, disconnect wallet
        await disconnectWallet();
      } else {
        console.log('Connecting wallet...');
        // If not connected, connect wallet
        await connectWallet();
      }
    } catch (error) {
      console.error('Error handling wallet action:', error);
      toast.error('Failed to connect/disconnect wallet');
    }
  };

  const connectWallet = async () => {
    try {
      console.log('Attempting to connect wallet...');
      
      if (!window.ethereum) {
        console.log('MetaMask not detected');
        toast.error('Please install MetaMask browser extension');
        return;
      }

      console.log('MetaMask detected, requesting access...');
      
      // First try to revoke permissions to force a fresh connection
      try {
        await window.ethereum.request({
          method: "wallet_revokePermissions",
          params: [{ eth_accounts: {} }]
        });
        console.log('Permissions revoked, requesting fresh connection...');
      } catch (revokeError) {
        console.log('Could not revoke permissions, proceeding with connection...');
      }
      
      // Request account access - this will prompt user to unlock if locked
      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });

      console.log('Received accounts:', accounts);

      if (accounts && accounts.length > 0) {
        setstatus(true);
        toast.success('Wallet connected successfully!');
        console.log('Wallet connection successful');
      } else {
        toast.error('No accounts returned from MetaMask');
        setstatus(false);
      }
    } catch (error) {
      console.error('Error connecting wallet:', error);
      console.error('Error details:', {
        code: error.code,
        message: error.message,
        stack: error.stack
      });
      
      setstatus(false);
      
      if (error.code === 4001) {
        toast.error('Wallet connection was rejected by the user');
      } else if (error.code === -32002) {
        toast.error('MetaMask is locked or connection request already pending. Please unlock MetaMask and try again.');
      } else if (error.message && error.message.includes('User rejected')) {
        toast.error('Wallet connection was rejected');
      } else if (error.message && error.message.includes('wallet_requestPermissions')) {
        toast.error('Request for account permission already pending');
      } else if (error.message && error.message.includes('locked')) {
        toast.error('MetaMask is locked. Please unlock your MetaMask extension and try again.');
      } else {
        toast.error(`Failed to connect wallet: ${error.message || 'Unknown error'}`);
      }
    }
  };

  const disconnectWallet = async () => {
    try {
      // Revoke MetaMask permissions to disconnect wallet
      if (window.ethereum) {
        await window.ethereum.request({
          method: 'wallet_revokePermissions',
          params: [{ eth_accounts: {} }]
        });
        console.log('Wallet permissions revoked successfully');
      }
      setstatus(false);
      toast.success('Wallet disconnected');
      
      // Optional: Clear any stored wallet data
      // localStorage.removeItem('walletAddress');
    } catch (error) {
      console.error('Error disconnecting wallet:', error);
      // Still set status to false even if revoke fails
      setstatus(false);
      toast.success('Wallet disconnected');
    }
  };
  return (
    <>
      <div
        style={{
          backgroundColor: "#F3F4F8",
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
      {role?<div 
        onClick={handleWalletAction}
        style={{
        padding: '12px 20px', // More breathing room
        color: 'white',
        textAlign: 'center',
        borderRadius: '8px', // Slightly larger radius for a softer edge
        margin: '10px',
        fontSize: '18px', // Larger font for better readability
        backgroundColor: status ? '#4CAF50' : '#ff4d4d', // Green if connected, red if not
        fontWeight: 'bold',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)', // Subtle shadow for depth
        transition: 'all 0.3s ease-in-out', // Smooth transition for background color
        cursor: 'pointer', // Pointer cursor on hover
        userSelect: 'none' // Prevent text selection
      }}
      onMouseEnter={(e) => e.target.style.boxShadow = '0px 6px 14px rgba(0, 0, 0, 0.3)'} // Darker shadow on hover
      onMouseLeave={(e) => e.target.style.boxShadow = '0px 4px 10px rgba(0, 0, 0, 0.2)'} // Revert shadow when not hovering
      title={status ? "Click to disconnect wallet" : "Click to connect wallet"}
    >
      {status ? "🔗 Connected" : "🔌 Connect Wallet"}
    </div>:""}
        {role ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-evenly",
              padding: 10,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-evenly",
                alignItems: "flex-end",
              }}
            >
              <span
                style={{ fontFamily: "Manrope, sans-serif", fontWeight: 600 }}
              >
                {first_Name || Last_Name ? `${first_Name} ${Last_Name}` : name}
              </span>
              <span
                style={{ fontFamily: "Manrope, sans-serif", color: "gray" }}
              >
                {role}
              </span>
            </div>

            <div
              style={{
                width: 50,
                height: 50,
                borderRadius: "50%",
                overflow: "hidden",
                margin: 10,
              }}
            >
              <img
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                src={lang ? lang : image}
                alt="Avatar"
                onError={(e) => {
                  console.log("🚀 ~ Image failed to load, lang:", lang, "image:", image);
                  // Show fallback avatar instead of hiding
                  e.target.src = profileImage; // Use the imported fallback image
                }}
                onLoad={() => {
                  console.log("🚀 ~ Image loaded successfully, src:", lang ? lang : image);
                }}
              />
            </div>

           
            {/* <img src={arrow}/> */}
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default Horizontal;
